import { motion } from "framer-motion";

const CTASection = () => {
  return (
    <section className="relative py-24 lg:py-16 overflow-hidden bg-black">
      
      {/* Background Glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[500px] h-[500px] bg-white/5 blur-3xl rounded-full" />

      <div className="relative max-w-6xl mx-auto px-4">
        
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
          className="bg-white/5 border border-white/10 backdrop-blur-xl rounded-[40px] p-10 lg:p-14 text-center"
        >
          
          {/* Tag */}
          <span className="inline-block text-sm uppercase tracking-[4px] text-gray-400">
            Get Started
          </span>

          {/* Heading */}
          <h2 className="text-4xl lg:text-6xl font-bold text-white mt-5 leading-tight">
            Ready To Upgrade 
            <br />
            Your HVAC Systems?
          </h2>

          {/* Description */}
          <p className="text-gray-300 mt-6 max-w-3xl mx-auto leading-8 text-base lg:text-lg">
            Discover high-performance HVAC coil solutions engineered
            for durability, energy efficiency, and long-lasting
            industrial performance for commercial and industrial
            applications.
          </p>

          {/* Buttons */}
          <div className="flex flex-wrap justify-center gap-5 mt-12">
            
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="px-8 py-4 rounded-full bg-white text-black font-semibold text-sm lg:text-base transition-all duration-300"
            >
              Contact Us
            </motion.button>

            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="px-8 py-4 rounded-full border border-white text-white font-semibold text-sm lg:text-base hover:bg-white hover:text-black transition-all duration-300"
            >
              View Products
            </motion.button>

          </div>

          {/* Bottom Stats */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 mt-16 pt-10 border-t border-white/10">
            
            <div>
              <h3 className="text-3xl font-bold text-white">
                500+
              </h3>
              <p className="text-gray-400 mt-2 text-sm">
                Projects Completed
              </p>
            </div>

            <div>
              <h3 className="text-3xl font-bold text-white">
                100%
              </h3>
              <p className="text-gray-400 mt-2 text-sm">
                Quality Tested Products
              </p>
            </div>

            <div>
              <h3 className="text-3xl font-bold text-white">
                24/7
              </h3>
              <p className="text-gray-400 mt-2 text-sm">
                Customer Support
              </p>
            </div>

          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;